import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttpUtility from "../utilities/useHttpUtility";
import LoadingScreen from "../components/LoadingScreen"
import Table from "../components/Table";

export default function PageRates() {

    const navigate = useNavigate();
    const http = useHttpUtility();

    const [data, setData] = useState(null);

    useEffect(() => {
        http.get("/api/Rates", setData);
    }, []);

    return (
        !data
            ? <LoadingScreen isFullScreen={true} />
            :
            <div className="page page-rates">
                <h2>Rates</h2>
                <Table
                    data={data}
                    mappings={
                        [
                            {
                                header: "Name",
                                field: "name"
                            },
                            {
                                header: "Type",
                                field: "rateType",
                                dataType: "rateType"
                            },
                            {
                                header: "Mode",
                                field: "rateMode",
                                dataType: "rateMode"
                            },
                            {
                                header: "Rate",
                                field: "rate"
                            }
                        ]
                    }
                    pageSize={20}
                    onClick={(idx) => navigate(`${data[idx].id}${window.location.search}`)}
                    onClickAdd={() => navigate(`0${window.location.search}`)} />
            </div>
    );
}